import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl/dist';
import { Table } from 'app-components';
import {  resultColumns } from './StateBasedTableConfig';

interface IHouseholdProps{
    data: any,
    screenType: string,
    handleShowMember?: any,
}
const HouseholdMembersTable = (householdTableProps: IHouseholdProps) => {
    const { data, screenType, handleShowMember } = householdTableProps;

    const NoResultsFound = () => {
        return (
            <div>
                <FormattedMessage id='archive.hh.no_results_found' />
            </div>
        );
    };

    return (
        <div>
            { data && data.length > 0 ? <Table data={data} columns={resultColumns(screenType)} hasBorders onSelectRow={ handleShowMember } /> : <NoResultsFound /> } 
        </div>
    )
};

export default connect(null, null)(HouseholdMembersTable);